import { axiosInstance } from "./axiosInstance";
import { Aprobacion, AprobacionCreada, AprobacionPreview } from "../../components/aprobaciones/tipos";

/*
	Aprobaciones por WappTeam (CONTRATO_PROMO_EN_CAMINO §2). El contrato no dice el prefijo: se usa el del plantel de la aprobación,
	como el resto de v2 (/admin/campus/{id}/…). Si el back las deja fuera del plantel, solo cambia `base`.
*/
const base = (campusId: number) => `/admin/campus/${campusId}/aprobaciones`;

export class AprobacionesService {
	get = async (campusId: number, id: number) => axiosInstance.get<Aprobacion>(`${base(campusId)}/${id}`);

	decidir = async (campusId: number, id: number, decision: "aprobar" | "rechazar", reason?: string) =>
		axiosInstance.post<Aprobacion>(`${base(campusId)}/${id}/_decidir`, { decision, ...(reason ? { reason } : {}) });

	retirar = async (campusId: number, id: number) => axiosInstance.post<Aprobacion>(`${base(campusId)}/${id}/_retirar`);

	/** «Enviar Otro Recordatorio»: un DM nuevo de WappTeam a cada aprobadora (400 si fue hace menos de un minuto). */
	recordar = async (campusId: number, id: number) => axiosInstance.post<Aprobacion>(`${base(campusId)}/${id}/_recordar`);

	lista = async (campusId: number, status: string, page = 1) =>
		axiosInstance.get<{ rows: Aprobacion[]; total: number }>(base(campusId), { params: { status, page } });

	/* Fase 2 (CONTRATO §5): vista previa y alta genérica. `data` = el mismo cuerpo que recibe hoy el endpoint de esa acción. */
	previewAprobacion = async (campusId: number, body: { kind: string; data: Record<string, any> }) =>
		axiosInstance.post<AprobacionPreview>(`${base(campusId)}/_preview`, body);

	crearAprobacion = async (campusId: number, body: { kind: string; data: Record<string, any>; reason: string; previewHash: string }) =>
		axiosInstance.post<AprobacionCreada>(base(campusId), body);
}
